module.exports = __webpack_public_path__ + "static/img/6.f45b054.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/3/99/zh/6.png
// module id = e07h
// module chunks = 0